import { createContext } from "react"

export type FinancialOverviewContextType =
	| { type: "custom"; from: string; to: string }
	| { type: "year"; year: string }

export const FinancialOverviewContext =
	createContext<FinancialOverviewContextType>(null!)
